import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/projects'

export default {
  edit(id, project) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, project)
  },
  create(project) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, project)
  },
  getProject(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  getList(client = '', page, per_page, search, orderBy, status = '', date_ini = '', date_fin = '') {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      client_id: client,
      page,
      per_page,
      search,
      orderBy,
      status,
      date_ini,
      date_fin,
    })
  },
  getSelect(client = '', page, per_page, search, orderBy, status = '', date_ini = '', date_fin = '') {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/select`, {
      client_id: client,
      page,
      per_page,
      search,
      orderBy,
      status,
      date_ini,
      date_fin,
    })
  },
}
